import { call, select } from 'redux-saga/effects'
import {getUserIdentity} from "state/app/selectors";
import {openURL} from "lib/native";

export default function* openURLSaga(action) {
  const userIdentity = yield select(getUserIdentity);
  return yield call(openURL, userIdentity.get("platform"), action.payload.url);
}



// WEBPACK FOOTER //
// ./src/state/app/sagas/openURL.js